// src/sidebar/Nav.js
import React, { useEffect, useRef } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import { FaBook } from 'react-icons/fa';

const Nav = ({ sidebar, toggleSidebar }) => {
  const sidebarRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        toggleSidebar();
      }
    };

    if (sidebar) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebar, toggleSidebar]);

  const handleLinkClick = () => toggleSidebar();

  return (
    <>
      {sidebar && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar - HIGHER z-index than header */}
      <nav
        ref={sidebarRef}
        className={`fixed top-0 left-0 h-full w-72 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${
          sidebar ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Header: Logo + Close */}
          <div className="flex items-center justify-between px-6 py-6 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              <FaBook className="text-3xl text-indigo-600" />
              <h2 className="text-2xl font-bold text-gray-800">Book Builder</h2>
            </div>
            <button
              onClick={toggleSidebar}
              className="text-gray-600 hover:text-gray-900 p-2 rounded-lg hover:bg-gray-100"
              aria-label="Close menu"
            >
              <AiOutlineClose className="text-2xl" />
            </button>
          </div>

          {/* Menu Items */}
          <ul className="flex-1 overflow-y-auto py-4">
            {SidebarData.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  onClick={handleLinkClick}
                  className="flex items-center px-6 py-4 text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-all duration-200 font-medium"
                >
                  <span className="mr-4 text-xl">{item.icon}</span>
                  <span>{item.title}</span>
                </Link>
              </li>
            ))}
          </ul>

          {/* Footer */}
          <div className="px-6 py-4 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center">© 2026 Book Builder</p>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Nav;